import { gql } from '@apollo/client'

export const TRANSFER_CALL_SUBSCRIPTION = gql`
  subscription TransferCallChanged($id: String!) {
    callChanged(id: $id) {
      id
      status
    }
  }
`
